// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"Chart_Zodiac_RadarChart2_graphContainer__3FdUT"};